import { styled } from "@linaria/react";
export const StyledContent = /*#__PURE__*/styled('div')({
  name: "StyledContent",
  class: "StyledContent_s11zskl9"
});

require("./StyledCategoryDescription.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledCategoryDescription.tsx");